module.exports = __webpack_public_path__ + "static/media/CYT-LOGO-1.ae818678.webp";